module.exports = __webpack_public_path__ + "static/media/photo37.df792c20.jpg";